import { render, staticRenderFns } from "./ProntuarioConsulta.vue?vue&type=template&id=24866064&"
import script from "./ProntuarioConsulta.vue?vue&type=script&lang=js&"
export * from "./ProntuarioConsulta.vue?vue&type=script&lang=js&"
import style0 from "./ProntuarioConsulta.vue?vue&type=style&index=0&id=24866064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports